module.exports = __webpack_public_path__ + "img/mo_super06.100595e0.png";